import { render, staticRenderFns } from "./dettagliUtenza.vue?vue&type=template&id=6bcac20f&"
import script from "./dettagliUtenza.vue?vue&type=script&lang=js&"
export * from "./dettagliUtenza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports